
import { Prop, Vue, Component, Watch } from "vue-property-decorator";
import CardContainer from "@/components/CardContainer/index.vue";
import { moneyFormat } from "@/utils/util";
import { getWorkbenchCashier } from "@/api/shouyin";

// 收银对账
@Component({
  components: {
    CardContainer,
  },
})
export class CashReconciliation extends Vue {
  @Prop({ default: () => ({}) }) params!: any;

  isInit = false;
  moneyFormat = moneyFormat;
  grids = [
    {
      label: "合计收银",
      value: "0",
      prop: "totalSaleMoney",
      isMoney: true,
    },
    {
      label: "合计充值",
      value: "0",
      prop: "totalTopUpMoney",
      isMoney: true,
    },
  ];
  @Watch("params", { deep: true, immediate: true })
  onParamsChange() {
    this.getData();
  }

  getData() {
    this.isInit = false;
    getWorkbenchCashier(this.params).then((res) => {
      this.grids.forEach((item) => {
        const value = res.data[item.prop] || "";

        if (item.isMoney) {
          const formatValue = `${moneyFormat(value, "")}`;
          item.value = formatValue === "--" ? "0.00" : formatValue;
        } else {
          item.value = value || "0";
        }
      });
      this.isInit = true;
    });
  }
}
export default CashReconciliation;
